import React, { useState, useEffect } from 'react';
import {
  TableOutlined,
  ApartmentOutlined,
} from '@ant-design/icons';
import { 
  Space, 
  Typography, 
  Switch,
} from 'antd';
import Layout from '../../components/Layout/Layout.jsx';
import DirectoryView from '../../components/DirectoryView/DirectoryView.jsx';
import TreeView from '../../components/TreeView/TreeView.jsx';
import './FilesPage.css';

const { Title } = Typography;

const FilesPage = () => {
  const [viewMode, setViewMode] = useState('directory'); // 'directory' or 'tree'

  // Load view preference from localStorage
  useEffect(() => {
    const savedViewMode = localStorage.getItem('fileViewMode');
    if (savedViewMode && ['directory', 'tree'].includes(savedViewMode)) {
      setViewMode(savedViewMode);
    }
  }, []);

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem('fileViewMode', viewMode);
  }, [viewMode]);

  const toggleViewMode = () => {
    setViewMode(viewMode === 'directory' ? 'tree' : 'directory');
  };

  return (
    <Layout showMenu={false}>
      <div className="files-page">
        <div className="files-header">
          <div className="header-top">
            <div className="header-left">
              <Title level={4} className="page-title">
                File Browser
              </Title>
            </div>
            <div className="header-right">
              <Space>
                <div className="view-toggle">
                  <Space>
                    <span>{'Directory View'}</span>
                    <TableOutlined />
                    <Switch
                      checked={viewMode === 'tree'}
                      onChange={toggleViewMode}
                      size="small"
                    />
                    <ApartmentOutlined />
                    <span>{'Tree View'}</span>
                  </Space>
                </div>
              </Space>
            </div>
          </div>
        </div>

        <div className="files-content">
          {viewMode === 'directory' ? (
            <DirectoryView />
          ) : (
            <TreeView />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default FilesPage; 